export * from './footer.component';
export * from './header.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/index.ts